import React, {useEffect, useState, useRef} from "react";
import {injectIntl} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {headerSortingClasses, sortCaret} from "../../../../_metronic/_helpers";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../_metronic/_partials/controls";
import {PaginationTable} from "../../../components/PaginationTable/PaginationTable";
import * as columnFormatters from "./column-formatters";
import { getProductsTenantPagination } from "./inventoryCrud";
import axios from "axios";

function InventoryPage(props) {
    const initialData = {
        data: [],
        totalCount: 0,
        pageSize: 10
    }

    const [data, setData] = useState(initialData)
    const [isMounted, setIsMounted] = useState(false)

    const {user, accessToken} = useSelector(
        ({auth}) => ({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    const dispatch = useDispatch();

    useEffect(() => {
        setIsMounted(true)
    }, [])

    const fetchProducts = async (queryParams) => {
        getProductsTenantPagination(accessToken, queryParams).then(response => {
            console.log("Products Response: ", response.data.data)
            const data = {
                data : response.data.data.map((product) => ({
                    ...product,
                    inventoryQty: product.qtyAvailable ?? product.qtyOnHand ?? 0,
                })),
                totalCount : response.data.totalCount,
                pageSize : 10
            }
            setData(data)
        }).catch(error => console.log(error))
    }

    const columns = [
        {
            dataField: "description",
            text: "Product",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.ProductNameFormatter,
        },
        {
            dataField: "category",
            text: "Category",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.CategoryFormatter,
        },
        {
            dataField: "inventoryQty",
            text: "Available Qty",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.QuantityFormatter,
        },
        {
            dataField: "price",
            text: "Price",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.PriceFormatter,
        },
        {
            dataField: "isActive",
            text: "Status",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.StatusFormatter,
        },
    ];

    const sizePerPageList = [
        {text: "10", value: 10},
        {text: "20", value: 20},
        {text: "50", value: 50}
    ]

    const initialFilter = {
        filter: {
            name:"",
            category:"",
            sku: "",
            description: "",
            supplierName: ""
        },
        sortOrder: "asc",
        sortField: "description",
        pageNumber: 1,
        pageSize: 10
    }

    const sorting = [{dataField: "description", order: "asc"}]
    const pagination = {custom: true, sizePerPageList: sizePerPageList}
    const tableClasses = "table table-head-custom table-head-bg table-borderless table-vertical-center "

    const prepareFilter = (queryParams,values) => {
        const {searchText} = values;
        const newQueryParams = {...queryParams};
        const filter = {};

        filter.name = searchText ?? "";
        filter.category = searchText ?? "";
        filter.sku = searchText ?? "";
        filter.description = searchText ?? "";
        filter.supplier = searchText ?? "";


        newQueryParams.filter = filter;
        return newQueryParams;
    }

    return (
        <>
            {isMounted ? 
                <Card>
                    <CardHeader title="All Products">
                        {/* <CardHeaderToolbar>
                        </CardHeaderToolbar> */}
                    </CardHeader>
                    <CardBody>
                        <PaginationTable
                            data={data}
                            columns={columns}
                            pagination={pagination}
                            isLoading={false}
                            sorting={sorting}
                            initialFilter={initialFilter}
                            tableClasses={tableClasses}
                            fetcher={fetchProducts}
                            filterFunction={prepareFilter}
                            searchField={true}
                            dateRangeField={false}/>
                    </CardBody>
                </Card>
                :
                null
            }
        </>
    );
}

export default injectIntl(InventoryPage);
